export const showPercentage=number=>{if(!number)return'0.0%';if(number>1)return'100.0%';return`${(Number(number)*100).toFixed(1)}%`;};